export const exchangePages = [
  {
    slug: "okx",
    name: "OKX",
    shortName: "OKX",
    referralCode: "HOANPHI50",
    totalRebate: "50%",
    sub: "Người mới, dễ dùng, phí thấp",
    quickStats: [
      "Giảm Phí OKX: 20% Hằng Ngày",
      "Giảm Phí OKX: 30% Hằng Tuần",
      "Tổng Hoàn Phí: 50%",
    ],
    link: "https://okx.com/join/HOANPHI50",
    logo: "/logo/okx.jpeg",
    logomini: "/logo/okxmini.png",
    logotext: "/logo/okxText.png",
    logoScale: 4.15,
    registerLabel: "Đăng Ký OKX",
    introTitle: "Hướng Dẫn Nhanh Cách Nhận Hoàn Phí OKX",
    supportText: "Đăng ký đúng link, nhập đúng mã giới thiệu và nhắn đội ngũ hỗ trợ để được gắn rebate nhanh hơn.",
    noAccountTitle: "Trường hợp chưa có tài khoản OKX",
    noAccountSteps: [
      "Đăng ký tài khoản OKX qua link giới thiệu của bạn.",
      "Hoàn tất xác minh danh tính và bảo mật cơ bản.",
      "Nạp tiền hoặc chuyển coin vào tài khoản để bắt đầu giao dịch.",
      "Nhắn admin để được xác nhận mã và kiểm tra trạng thái hoàn phí.",
    ],
    hasAccountTitle: "Trường hợp đã có tài khoản OKX",
    hasAccountSteps: [
      "Kiểm tra xem tài khoản đã từng nhập mã giới thiệu chưa.",
      "Nếu chưa có rebate, liên hệ hỗ trợ để được kiểm tra điều kiện gắn mã.",
      "Gửi UID hoặc email đăng ký để đội ngũ xử lý nhanh hơn.",
      "Sau khi xác nhận thành công, bắt đầu giao dịch và theo dõi rebate định kỳ.",
    ],
  },
  {
    slug: "mexc",
    name: "Mexc",
    shortName: "Mexc",
    referralCode: "HOANPHI50",
    totalRebate: "50%",
    sub: "Altcoin nhiều, phí thấp",
    quickStats: [
      "Hoàn Bởi Mexc: 20% trực tiếp",
      "Hoàn Bởi IB: 30% hằng tuần",
      "Tổng Hoàn Phí: 50%",
    ],
    link: "https://promote.mexc.com/b/HoanPhi50",
    logo: "/logo/mexc.png",
    logomini: "/logo/mexcmini.png",
    logotext: "/logo/MexcText.png",
    logoScale: 4.5,
    registerLabel: "Đăng Ký Bitget",
    introTitle: "Hướng Dẫn Nhanh Cách Nhận Hoàn Phí Bitget",
    supportText: "Bitget nổi bật ở mảng futures và copy trade, hợp để làm một route riêng như ảnh mẫu của bạn.",
    noAccountTitle: "Trường hợp chưa có tài khoản Bitget",
    noAccountSteps: [
      "Đăng ký qua link đối tác.",
      "KYC và kiểm tra quyền dùng futures/copy trade.",
      "Nhập mã rx7u7usk nếu biểu mẫu yêu cầu.",
      "Liên hệ đội ngũ để xác nhận trạng thái rebate.",
    ],
    hasAccountTitle: "Trường hợp đã có tài khoản Bitget",
    hasAccountSteps: [
      "Gửi UID để hỗ trợ kiểm tra tài khoản hiện tại.",
      "Xem điều kiện chuyển đổi hoặc gắn mã nếu sàn cho phép.",
      "Theo dõi rebate hằng tuần sau khi hoàn tất xác nhận.",
      "Tối ưu giao dịch và liên hệ hỗ trợ nếu thiếu hoàn phí.",
    ],
  },
  {
    slug: "bybit",
    name: "Bybit",
    shortName: "BYBIT",
    referralCode: "HOANPHI50",
    totalRebate: "44%",
    sub: "Khớp lệnh nhanh, Speed cao",
    quickStats: [
      "Hoàn Bởi Bybit: sàn không hỗ trợ trực tiếp",
      "Hoàn Bởi IB: 50% hằng tuần",
      "Tổng Hoàn Phí: 50%",
    ],
    link: "https://partner.bybit.com/b/HOANPHI50",
    logo: "/logo/bybit.png",
    logomini: "/logo/bybitmini.png",
    logotext: "/logo/bybitText.png",
    logoScale: 4.2,
    registerLabel: "Đăng Ký Bybit",
    introTitle: "Hướng Dẫn Nhanh Cách Nhận Hoàn Phí Bybit",
    supportText: "Bybit thường xử lý theo mô hình rebate từ đối tác, nên bước xác nhận mã giới thiệu rất quan trọng.",
    noAccountTitle: "Trường hợp chưa có tài khoản Bybit",
    noAccountSteps: [
      "Đăng ký tài khoản Bybit qua link của bạn.",
      "Nhập đúng mã giới thiệu TLS1 nếu form yêu cầu.",
      "KYC và bật bảo mật 2 lớp trước khi giao dịch.",
      "Nhắn hỗ trợ để xác nhận đã vào đúng hệ thống hoàn phí.",
    ],
    hasAccountTitle: "Trường hợp đã có tài khoản Bybit",
    hasAccountSteps: [
      "Kiểm tra trạng thái affiliate/referral hiện tại của tài khoản.",
      "Nếu tài khoản chưa gắn mã, liên hệ đội ngũ để kiểm tra khả năng hỗ trợ.",
      "Gửi UID hoặc email đăng ký cho admin.",
      "Theo dõi rebate hằng tuần và lịch thanh toán từ đội hỗ trợ.",
    ],
  },
  {
    slug: "binance",
    name: "Binance",
    shortName: "BIN",
    referralCode: "813528158",
    totalRebate: "40%",
    sub: "Thanh khoản lớn",
    quickStats: [
      "Hoàn Bởi Binance: 20% trực tiếp",
      "Hoàn Bởi IB: 25% hằng tuần",
      "Tổng Hoàn Phí: 45%",
    ],
    link: "https://accounts.binance.com/register?ref=813528158",
    logo: "/logo/binance.png",
    logomini: "/logo/binancemini.png",
    logotext: "/logo/BinanceText.svg",
    registerLabel: "Đăng Ký Binance",
    introTitle: "Hướng Dẫn Nhanh Cách Nhận Hoàn Phí Binance",
    supportText: "Binance thường rõ ở phần kickback khi đăng ký, nhưng bạn vẫn nên kiểm tra kỹ trước khi giao dịch.",
    noAccountTitle: "Trường hợp chưa có tài khoản Binance",
    noAccountSteps: [
      "Đăng ký qua link giới thiệu của bạn.",
      "Kiểm tra phần kickback/referral trước khi xác nhận tài khoản.",
      "KYC để mở đủ quyền giao dịch futures hoặc spot.",
      "Nhắn admin để lưu thông tin và hỗ trợ sau đăng ký.",
    ],
    hasAccountTitle: "Trường hợp đã có tài khoản Binance",
    hasAccountSteps: [
      "Kiểm tra tài khoản hiện tại đã gắn mã rebate hay chưa.",
      "Nếu cần, liên hệ hỗ trợ để được tư vấn giải pháp phù hợp.",
      "Không nên tự tạo nhiều tài khoản nếu chưa hiểu chính sách của sàn.",
      "Theo dõi rebate và lịch đối soát định kỳ.",
    ],
  },
  {
    slug: "bingx",
    name: "BingX",
    shortName: "BGX",
    referralCode: "GRIWGPDA",
    totalRebate: "50%",
    sub: "Copy trade, dễ dùng",
    quickStats: [
      "Hoàn Bởi BingX: 20% trực tiếp",
      "Hoàn Bởi IB: 30% hằng tuần",
      "Tổng Hoàn Phí: 50%",
    ],
    link: "https://bingxdao.com/invite/GRIWGPDA/",
    logo: "/logo/bingx.png",
    logomini: "/logo/bingxmini.jpeg",
    logotext: "/logo/BingXText.png",
    logoScale: 4.1,
    registerLabel: "Đăng Ký BingX",
    introTitle: "Hướng Dẫn Nhanh Cách Nhận Hoàn Phí BingX",
    supportText: "BingX phù hợp với người dùng thích copy trade hoặc giao diện dễ tiếp cận.",
    noAccountTitle: "Trường hợp chưa có tài khoản BingX",
    noAccountSteps: [
      "Đăng ký bằng link hoặc mã giới thiệu GRIWGP.",
      "KYC, bật bảo mật và kiểm tra khu vực được hỗ trợ.",
      "Nạp vốn và bắt đầu giao dịch sau khi xác nhận rebate.",
      "Lưu lại UID để đội hỗ trợ đối soát nhanh hơn.",
    ],
    hasAccountTitle: "Trường hợp đã có tài khoản BingX",
    hasAccountSteps: [
      "Kiểm tra tài khoản cũ có đang nhận rebate hay không.",
      "Gửi UID để hỗ trợ kiểm tra điều kiện tham gia hệ thống.",
      "Xác nhận lịch thanh toán và tỷ lệ hoàn phí hiện tại.",
      "Bắt đầu giao dịch sau khi nhận thông báo xác nhận.",
    ],
  },
  {
    slug: "bitget",
    name: "Bitget",
    shortName: "BGT",
    referralCode: "rx7u7usk",
    totalRebate: "50%",
    sub: "Copy trade, bonus",
    quickStats: [
      "Hoàn Bởi Bitget: 20% trực tiếp",
      "Hoàn Bởi IB: 30% hằng tuần",
      "Tổng Hoàn Phí: 50%",
    ],
    link: "https://partner.bitget.com/bg/rx7u7usk",
    logo: "/logo/bitget.png",
    logomini: "/logo/bitgetmini.png",
    logotext: "/logo/BitgetText.png",
    logoScale: 1.1,
    registerLabel: "Đăng Ký Bitget",
    introTitle: "Hướng Dẫn Nhanh Cách Nhận Hoàn Phí Bitget",
    supportText: "Bitget nổi bật ở mảng futures và copy trade, hợp để làm một route riêng như ảnh mẫu của bạn.",
    noAccountTitle: "Trường hợp chưa có tài khoản Bitget",
    noAccountSteps: [
      "Đăng ký qua link đối tác.",
      "KYC và kiểm tra quyền dùng futures/copy trade.",
      "Nhập mã rx7u7usk nếu biểu mẫu yêu cầu.",
      "Liên hệ đội ngũ để xác nhận trạng thái rebate.",
    ],
    hasAccountTitle: "Trường hợp đã có tài khoản Bitget",
    hasAccountSteps: [
      "Gửi UID để hỗ trợ kiểm tra tài khoản hiện tại.",
      "Xem điều kiện chuyển đổi hoặc gắn mã nếu sàn cho phép.",
      "Theo dõi rebate hằng tuần sau khi hoàn tất xác nhận.",
      "Tối ưu giao dịch và liên hệ hỗ trợ nếu thiếu hoàn phí.",
    ],
  },
];

export const partnerLogos = exchangePages.map((item) => ({
  name: item.name,
  slug: item.slug,
  shortName: item.shortName,
  href: `/${item.slug}`,
}));

export function getExchangeBySlug(slug) {
  return exchangePages.find((item) => item.slug === slug);
}
